import { render, staticRenderFns } from "./AdminTestPayment.vue?vue&type=template&id=64e1476d&scoped=true&"
import script from "./AdminTestPayment.vue?vue&type=script&lang=js&"
export * from "./AdminTestPayment.vue?vue&type=script&lang=js&"
import style0 from "./AdminTestPayment.vue?vue&type=style&index=0&id=64e1476d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e1476d",
  null
  
)

export default component.exports